import { VirtualEventDetails } from 'modules/virtualClassrooms/common/types/manager'
import { EventEditorFormParams } from 'modules/virtualClassrooms/manager/EventDetails/types/eventEditor'

class EventEditorUtils {
  DEFAULT_PARTICIPANTS_MAX_NUMBER = 20

  mapEventDetailsToFormParams(eventDetails?: VirtualEventDetails): EventEditorFormParams {
    const {
      title,
      categoryId,
      description,
      maximumParticipants,
      allowParticipantsToSelfBook,
      allowParticipantsToJoinWaitList,
      enableRecordingDownload,
    } = eventDetails || {}

    return {
      title: title || '',
      categoryId: categoryId || '',
      description: description || '',
      maximumParticipants: maximumParticipants || this.DEFAULT_PARTICIPANTS_MAX_NUMBER,
      allowParticipantsToSelfBook: allowParticipantsToSelfBook || false,
      allowParticipantsToJoinWaitList: allowParticipantsToJoinWaitList || false,
      enableRecordingDownload: enableRecordingDownload || false,
    }
  }
}

export default new EventEditorUtils()
